// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormLabel_wrapper__3kTWg","label":"FormLabel_label__3cle0"};